// extracted by mini-css-extract-plugin
export default {"clients_container":"Clients_clients_container__-O0xI","clients_head":"Clients_clients_head__Ug9qN","swiper":"Clients_swiper__Kvex9","bottom":"Clients_bottom__mMB6s"};